import { Api } from "../api";
import { KeywordList } from "../model/keyword_list";

export class KeywordListRepo {
    private readonly cacheKey = "keywordListsKey";

    async getAllKeywordLists(): Promise<KeywordList[] | Error> {
        let result = await Api.listGetAll();
        if (result instanceof Error) {
            return result;
        }
        this.setCachedKeywordList(result);
        return result;
    }

    getCachedKeywordList(): KeywordList[] {
        try {
            const cacheStr = localStorage.getItem(this.cacheKey);
            if (cacheStr) {
                return JSON.parse(cacheStr);
            }
            return [];
        } catch (error) {
            console.error("Error getting cached keyword list:", error);
            return [];
        }
    }

    private setCachedKeywordList(keywordLists: KeywordList[]): void {
        try {
            localStorage.setItem(this.cacheKey, JSON.stringify(keywordLists));
        } catch (error) {
            console.error("Error setting cached keyword list:", error);
        }
    }
}
